import Formsy from 'formsy-react'
import { priceDisplay } from 'helpers/price';
import React, { Component } from 'react'
import { Container, Dropdown, Grid, Header, Pagination, Segment, Tab, Table, Button, Icon, Label } from 'semantic-ui-react';
import { getCategoryList } from 'services/Categories';
import { getMarkets, getChurnCandidates, prioritizeSellerForJob } from 'services/Manager';
import { getSubscriptionStatus } from 'services/SellerSubscription';
import moment from 'moment';
import './ChurnCandidatesContainer.less'
import GoogleMapReact from 'google-map-react';
import Config from 'Config';
import Marker from '../../components/GMaps/Marker';
import { IN_TRIAL } from 'constants/SellerSubscriptionStatus';
import SellerAdditionalInfo from 'components/SellerAdditionalInfo/SellerAdditionalInfo';

const rowsPerPage = 20;

const initialState = {
    categories: [],
    subStatus: [],
    markets: [],
    marketListOriginal: [],
    currentCategoryValue: '',
    currentCategoryText: '',
    currentStatusValue: '',
    currentStatusText: '',
    currentMarketValue: '',
    currentMarketText: '',
    page: 1,
    subscriptionList: [],
    subscriptionListForMap: [],
    pageChange: false,
    showMap: false,
    mapCenter:{lat: 39.8097343, lng: -98.5556199},
    zoomLevel: 1,
    acceptingJobStatuses: [],
    selectedAcceptingJobStatus: 'all',
    daysSinceLeadCount: 0,

    currentSellerName: '',
    currentSellerID: 0,
    currentAdditionalInfo: '',
    openNotes: false
};

class ChurnCandidatesContainer extends Component {

    static defaultProps = {
        USCenter: {
            lat: 39.8097343, 
            lng: -98.5556199
        },
        zoom: 1
      };

    constructor(props){
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        const subStatusPromise = getSubscriptionStatus();
        const categoryPromoise = getCategoryList();
        const marketPromise = getMarkets();

        Promise.all([subStatusPromise, categoryPromoise, marketPromise]).then(([subStatusRes, categoryRes, marketRes]) => {
            const categoryList = this.populateCategories(categoryRes.data);
            const statusList = this.populateSubscriptionStatus(subStatusRes.data);
            const marketList = this.populateMarkets(marketRes.data);

            this.setState({
                categories: categoryList, 
                currentCategoryText: 'All Categories', 
                currentCategoryValue: '',
                subStatus: statusList, 
                markets: marketList, 
                marketListOriginal: marketRes.data,
                currentMarketText: 'Any Market', 
                currentMarketValue: ''
            }, () => {
                this.onSearch();
            });
        });

        const status = [];
        status.push({value: 'true', text: 'Yes'});
        status.push({value: 'false', text: 'No'});
        status.push({value: 'all', text: 'All', selected: true});
        this.setState({acceptingJobStatuses: status});
    }

    populateCategories = (categories) => {
        let categoryList = _.map(categories, cat => {
            return {value: cat.seoName, text: cat.name}
        });

        categoryList = [{value: '', text: 'All Categories'}, ...categoryList];
        return categoryList;
    }

    populateSubscriptionStatus = (status) => {

        status = _.filter(status, st => st.name != 'Suspended' && st.name != 'Cancelled')
        let statusList = _.map(status, st => {
            return {value: st.name, text: st.name}
        });

        statusList = [{value: '', text: 'Any Status'}, ...statusList];
        return statusList;
    }

    populateMarkets = (markets) => {
        let marketList = _.map(markets, market => {
            return {value: market.marketID, text: market.name}
        });

        marketList = [{value: '', text: 'Any Market'}, ...marketList];
        return marketList;
    }

    onCategoryChange = (e, data) => {
        const selectedCategory = _.first(_.filter(this.state.categories, item => item.value == data.value));
        this.setState({currentCategoryValue: selectedCategory.value, currentCategoryText: selectedCategory.text})
    }

    onStatusChange = (e, data) => {
        const selectedStatus = _.first(_.filter(this.state.subStatus, item => item.value == data.value));
        this.setState({currentStatusValue: selectedStatus.value, currentStatusText: selectedStatus.text})
    }

    onMarketChange = (e, data) => {
        const selectedMarket = _.first(_.filter(this.state.markets, item => item.value == data.value));
        this.setState({currentMarketValue: selectedMarket.value, currentMarketText: selectedMarket.text})
    }  

    onSearch = async (e, data) => {
        // this.setState({page: 1});
        // this.search();
        this.setState({page: 1, pageChange: true}, () => {
            this.search();
        });
    }

    search = async () => {
        const subscriptionListRes = await getChurnCandidates(this.state.page, rowsPerPage, this.state.currentCategoryValue, this.state.currentMarketValue, this.state.selectedAcceptingJobStatus);
        this.setState({subscriptionList: subscriptionListRes.data.subscriptionList, daysSinceLeadCount: subscriptionListRes.data.daysSinceLeadCount, subscriptionListCount: subscriptionListRes.data.count});
        if(!this.state.pageChange) {
            
            const market = _.first(_.filter(this.state.marketListOriginal, m => m.marketID == this.state.currentMarketValue));
            if(market){
                this.setState({mapCenter: {lat: +market.lat, lng: +market.lon}, zoomLevel: 7});
            }
            else{
                this.setState({mapCenter: +this.props.USCenter, zoomLevel: +this.props.zoom});
            }
            //const subscriptionListMapRes = await getSubscriptionList(-1, rowsPerPage, this.state.currentCategoryValue, this.state.currentStatusValue, this.state.currentMarketValue, true);
            //this.setState({subscriptionListForMap: subscriptionListMapRes.data.subscriptionList});
        }

        this.setState({pageChange: false});
    }

    onPageChange = (e, data) => {
        this.setState({page: data.activePage, pageChange: true}, () => {
            this.search();
        });
        
    }

    onShowMapClick = () => {
        this.setState({showMap: true});
    }
    onShowGridClick = () => {
        this.setState({showMap: false});
    }

    createMapOptions = (maps) => {
        return {
          fullscreenControl: false,
    
        }
      }

    //   removePriority = async (sellerID) => {
    //     const res = await prioritizeSellerForJob(sellerID, false);

    //     if(res.resStatus == 200){
    //         this.setState({pageChange: true}, () => {
    //             this.search();
    //         });
            
    //     }
    // }

    applyPriority = async (sellerID) => {
        const res = await prioritizeSellerForJob(sellerID, true);
        if(res.resStatus == 200){
            this.setState({pageChange: true}, () => {
                this.search();
            });
        }
    }

    onAcceptingJobsStatusChange = (e, data) => {
        this.setState({selectedAcceptingJobStatus: data.value});
    }

    onShowSellerInfoModal = (sellerName, sellerID, additionalInfo) => {

        this.setState({
            currentSellerName: sellerName,
            currentSellerID: sellerID,
            currentAdditionalInfo: additionalInfo,
            openNotes: true
        })
        
    }

    onNotesEditingDone = () => {
        this.setState({
            currentSellerName: '',
            currentSellerID: 0,
            currentAdditionalInfo: '',
            openNotes: false
        })
    }

    render() {
        return (
            <Container fluid className="active-subscription-container">
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header">
                            <div className="main-heading">
                                Churn Candidates
                            </div>
                        </div>
                        <Segment className="filter-segment">
                            <Formsy onValidSubmit={this.onSearch}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Categories</Header>
                                            <Dropdown fluid name="category" key="act-sub-fil-category" 
                                            selection
                                            options={this.state.categories}
                                            value={this.state.currentCategoryValue}
                                            text={this.state.currentCategoryText}
                                            onChange={this.onCategoryChange}
                                            ></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {/*<Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Status</Header>
                                            <Dropdown fluid name="sub-status" key="act-sub-fil-sub-status"
                                            selection
                                            options={this.state.subStatus}
                                            value={this.state.currentStatusValue}
                                            text={this.state.currentStatusText}
                                            onChange={this.onStatusChange}
                                            ></Dropdown>
                                        </Grid.Column>
                                    </Grid.Row>*/}
                                    <Grid.Row>
                                        <Grid.Column width={8}>
                                            <Header>Markets</Header>
                                            <Dropdown fluid name="markets" key="act-sub-fil-markets"
                                            selection
                                            options={this.state.markets}
                                            value={this.state.currentMarketValue}
                                            text={this.state.currentMarketText}
                                            onChange={this.onMarketChange}></Dropdown>
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            <Header>Accepting Jobs</Header>
                                            <Dropdown className="list-box" 
                                            placeholder='Status' 
                                            fluid 
                                            selection 
                                            options={this.state.acceptingJobStatuses} 
                                            onChange={this.onAcceptingJobsStatusChange} 
                                            value={this.state.selectedAcceptingJobStatus} />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <button className="button-submit">Search</button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Formsy>
                        </Segment>
                        {/*<Button.Group basic size="large" className="button-group">
                            <Button onClick={this.onShowGridClick} className={!this.state.showMap ? 'selected' : ''}>
                                <Icon name="table" />
                                List </Button>
                            <Button onClick={this.onShowMapClick} className={this.state.showMap ? 'selected' : ''}>
                                <Icon name="map" />
                                Map </Button>

                                </Button.Group>*/}
                        <Segment className={`content-segment ${this.state.showMap ? 'hidden' : 'visible'}`}>
                            
                            <Container fluid>
                                <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.subscriptionListCount / rowsPerPage)} activePage={this.state.page} onPageChange={this.onPageChange} />
                            </Container>
                            <Table celled striped>
                            
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Email</Table.HeaderCell>
                                        <Table.HeaderCell>Business</Table.HeaderCell>
                                        <Table.HeaderCell>Phone</Table.HeaderCell>
                                        <Table.HeaderCell>Category</Table.HeaderCell>
                                        <Table.HeaderCell>Plan</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Start</Table.HeaderCell>
                                        <Table.HeaderCell>Price</Table.HeaderCell>
                                        <Table.HeaderCell>Lead Fee</Table.HeaderCell>
                                        {/* <Table.HeaderCell>Commision %</Table.HeaderCell> */}
                                        {/*<Table.HeaderCell>Referral</Table.HeaderCell>*/}
                                        <Table.HeaderCell>Last Payment Date</Table.HeaderCell>
                                        <Table.HeaderCell>Next Payment Date</Table.HeaderCell>
                                        <Table.HeaderCell>Next Payment</Table.HeaderCell>
                                        <Table.HeaderCell>Last Payment</Table.HeaderCell>
                                        <Table.HeaderCell>Last Bid Accepted</Table.HeaderCell>
                                        <Table.HeaderCell>{`Job Count (${this.state.daysSinceLeadCount}) days`}</Table.HeaderCell>
                                        <Table.HeaderCell>Billing Cycle Job Count</Table.HeaderCell>
                                        <Table.HeaderCell>Accepting Jobs</Table.HeaderCell>
                                        <Table.HeaderCell>Notes</Table.HeaderCell>   
                                        
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        this.state.subscriptionList.length > 0 &&
                                        _.map(this.state.subscriptionList, sub => {
                                            return <Table.Row>
                                                <Table.Cell className='email'>
                                                    {sub.email}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.sellerName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.cellPhone}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.categoryName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.planName}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.subStatus}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(sub.start).format('DD MMM YYYY')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {priceDisplay(sub.price)}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.commission ? `${sub.commission}%` : `${priceDisplay(sub.referralFee)}`}
                                                </Table.Cell>
                                                {/*<Table.Cell>
                                                    {sub.referralFee ? `${priceDisplay(sub.referralFee)}` : '-'}
                                                </Table.Cell>*/}
                                                <Table.Cell>
                                                    {sub.lastPaymentDate ? moment(sub.lastPaymentDate).format('DD MMM YYYY') : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.nextPaymentDate ? moment(sub.nextPaymentDate).format('DD MMM YYYY') : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.nextPaymentAmount ? `${priceDisplay(sub.nextPaymentAmount)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.lastPaymentAmount ? `${priceDisplay(sub.lastPaymentAmount)}` : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.lastBidAcceptedDate ? moment(sub.lastBidAcceptedDate).format('DD MMM YYYY') : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.jobCount ? sub.jobCount : '-'}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.toDateBillCycleJobCount}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {sub.acceptingJobs ? `Yes` : `No`} {sub.acceptingJobsLastUpdatedOn ? `since ${moment().diff(moment(sub.acceptingJobsLastUpdatedOn), 'day')} day(s)`: ''}
                                                </Table.Cell>
                                                <Table.Cell className="table-cell">
                                        
                                        {sub.additionalInfo && _.trim(sub.additionalInfo).length > 0 ?<> <div className="notes-div">{sub.additionalInfo} </div><span><Icon name="pencil" style={{color: '#21ba45', cursor: 'pointer'}} size='small' onClick={() => this.onShowSellerInfoModal(sub.sellerName, sub.sellerID, sub.additionalInfo)} /></span></> : 
                                                    <Icon name="sticky note outline" style={{color: '#21ba45', cursor: 'pointer'}} size='large' onClick={() => this.onShowSellerInfoModal(sub.sellerName, sub.sellerID, sub.additionalInfo)} /> }
                                                
                                    </Table.Cell>
                                            </Table.Row>
                                        })
                                    }
                                    {
                                        this.state.subscriptionList.length == 0 && <Table.Row>
                                            <Table.Cell colspan={16}>
                                                No record found
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                </Table.Body>
                            </Table>
                            <Container fluid>
                                <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.subscriptionListCount / rowsPerPage)}   activePage={this.state.page} onPageChange={this.onPageChange} />
                            </Container>
                        </Segment>
                        <Segment className={`map content-segment ${this.state.showMap ? 'visible' : 'hidden'}`}>
                            
                            <GoogleMapReact
                            bootstrapURLKeys={{ key: Config.maps.key, language: 'en', region: 'us' }}
                            defaultZoom={this.props.zoom}
                            zoom={this.state.zoomLevel}
                            center={this.state.mapCenter}
                            options={this.createMapOptions}
                            defaultCenter={this.props.USCenter}
                            
                
                          >
                            
                                {
                                    this.state.subscriptionListForMap && _.map(this.state.subscriptionListForMap, data => {

                                        return <Marker trial={data.subStatus == IN_TRIAL} subscribed={true}
                                            lat={data.lat} lng={data.lon} title={data.sellerName}
                                            phone={data.cellPhone} sellerid={data.sellerID} />
                                        /*onMarkerMouseOver={this.onMarkerMouseOver} onMarkerMouseOut={this.onMarkerMouseOut} onMarkerClick={this.onMarkerClick} />*/


                                    })
                                }
                            
                            </GoogleMapReact>
                        </Segment>
                    </div>
                </div>
                <SellerAdditionalInfo 
                sellerID={this.state.currentSellerID} 
                sellerName={this.state.currentSellerName} 
                additionalInfo={this.state.currentAdditionalInfo} 
                open={this.state.openNotes} 
                refreshList={this.search}
                close={this.onNotesEditingDone} />
            </Container>
        )
    }
}

export default ChurnCandidatesContainer
